module.exports = __webpack_public_path__ + "img/complete_01.d0104249.png";